export function initEvents({ onScroll, onResize }) {
	// SCROLL (throttled)
	if (onScroll) {
		let last = 0;
		window.addEventListener("scroll", () => {
			const now = Date.now();
			if (now - last >= 100) {
				onScroll();
				last = now;
			}
		});
	}

	// RESIZE (debounced)
	if (onResize) {
		let timeout;
		window.addEventListener("resize", () => {
			clearTimeout(timeout);
			timeout = setTimeout(onResize, 300);
		});
	}
}